<template>
  <div class="page">
    <div class="page-head">
      <div class="mains-content scroll-auto">
        <div class="tops-between">
          <div class="tops-title">
            <p>资金上缴</p>
          </div>
          <div class="flex-row">
            <el-button type="primary" v-perm="{key:'fundtransfer', value:'fundtransfer:add'}" @click="cashPaid">立即上缴</el-button>
            <el-button type="primary" v-perm="{key:'fundtransfer', value:'fundtransfer:listRecord'}" @click="paymentRecords">上缴记录</el-button>
          </div>
        </div>
        <div class="member-content-box">
          <div class="boxs" v-perm="{key:'fundtransfer', value:'fundtransfer:list'}">
            <p class="titles">
              <img :src="downloadUrl" alt class="icon" />
              <span>现金结余</span>
              <el-date-picker
              v-model="dateMonth"
              type="monthrange"
              class="ml10"
              value-format="yyyy-MM"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              @change="timeChange">
            </el-date-picker>
            </p>
            <el-row class="rows">
              <el-col class="cols" :span="4">
                <p class="van-text">现金收款</p>
                <p class="van-label">{{amount.fundAmount || 0}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">累计上缴</p>
                <p class="van-label">{{amount.finishAmount || 0}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">现金结余</p>
                <p class="van-label">{{amount.residueAmount || 0}}</p>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="mains-bottom">
        <div class="back el-icon-back" @click="back"></div>
      </div>
    </div>
    <edit ref="editForm" @change="editChange"></edit>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import edit from "./edit.vue"
export default {
  mixins: [minxin],
  data() {
    return {
      amount: {},
      downloadUrl: require("../../../assets/images/home/data.png"),
      query: {
        beginTime: '',
        endTime: ''
      },
      dateMonth: [new Date(), new Date()]
    };
  },
  components: {edit},
  created() {
    this.query.beginTime = this.formatMonth(new Date())  + '-01';
    console.log(this.query.beginTime);
    this.query.endTime = this.query.beginTime;
    this.pageDetailByShop();
  },
  methods: {
    back() {
      this.$router.push('/collectMoney');
    },
    pageDetailByShop() {
      this.$api
        .post(this.$url.fundTransferSum.get, {
          beginTime: this.query.beginTime,
          endTime: this.query.endTime
        })
        .then(res => {
          this.amount = res;
        })
        .catch(error => {
          this.error = true;
        });
    },
    cashPaid () {
      this.$refs["editForm"].$emit("set")
    },
    editChange (org) {
      if (org) this.pageDetailByShop();
    },
    paymentRecords () {
      this.$router.push("/manage/paymentRecords")
    },
    timeChange (val) {
      console.log(val)
      this.query.beginTime = val[0] + '-01';
      this.query.endTime = val[1] + '-01';
      this.pageDetailByShop();
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
* {
  box-sizing: border-box;
}
.page-head {
  height: 700px;
}
.mains-bottom {
    width: 100%;
  .back {
    position: absolute;
    left: 26px;
  }
  position: relative;
  background-color: #fff;
  height: 62px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mains-content {
  height: calc(100% - 72px);
  .tops-between {
    background: #fff;
    display: flex;
    justify-content: space-between;
    padding: 0 25px;
    align-items: center;
    // border-bottom: 2px solid @borderColor;
  }
  .tops-title {
    width: 100%;
    box-sizing: border-box;

    p {
      font-size: 18px;
      font-weight: 500;
      height: 60px;
      line-height: 60px;
      font-weight: bold;
      span {
        color: @blue;
      }
    }
    .add-btns {
      width: 100px;
      height: 32px;
    }
  }
  .member-content-box {
    border-top: 2px solid @borderColor;
  }
  .member-header {
    background: #fff;
    height: 56px;
    padding: 0 25px;
    display: flex;
    align-items: center;
    border-bottom: 2px solid @borderColor;

    .setDate {
      margin-right: 15px;
    }
    .top-label {
      width: 90px;
    }
  }
}
.more-boxs {
  display: flex;
}
.boxs-left {
  width: 423px;
  margin-right: 10px;
}
.boxs-center {
  width: 530px;
}
.boxs-right {
  width: 277px;
  margin-left: 10px;
}
.boxs {
  margin-top: 10px;
  background: #fff;
  padding: 20px 26px;
  // .titles {
  //   font-size: 18px;
  //   font-weight: bold;
  // }
  .titles {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    span {
      margin-left: 10px;
    }
  }
  .cols {
    margin-top: 20px;
    text-align: center;
    .van-label {
      margin-bottom: 10px;
      font-weight: bold;
    }
  }
}
</style>